import styled from 'styled-components';
import Link from 'next/link';
import { mqLargeMin } from 'styled/tools/media-queries';
import { Fontw4s18h28, Fontw5s18h24 } from 'styles/commonCss';
import { trackButtonEvent } from 'lib/analytics';
import { mqSmallMax } from 'styled/tools/media-queries';

const Section = styled.section`
  background-color: var(--guidance-secondary);
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  margin-top: -8px;

  @media ${mqSmallMax} {
    padding: 24px;
    gap: 0px;
  }

  @media ${mqLargeMin} {
    flex-direction: row;
    gap: 145px;
  }
`;

const Description = styled.p`
  ${Fontw4s18h28}
  color: var(--text-primary);
  margin-bottom: 24px;
  width: 100%;

  @media ${mqLargeMin} {
    margin-bottom: 0px;
    width: 48%;
  }
`;

const PractitionerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;
  align-self: stretch;

  @media ${mqSmallMax} {
    width: 100%;
  }

  @media ${mqLargeMin} {
    flex-direction: column;
  }
`;

const PractitionerButton = styled.button`
  ${Fontw5s18h24}
  background-color: var(--guidance-secondary);
  display: flex;
  height: 60px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid var(--outline-primary);
  cursor: pointer;
  width: 398px;
`;

const ConnectCta = (hashedAccountInfo) => (
  <Section>
    <Description>
      We founded Seed Health to realize the microbiome as a radical new pathway
      for well-being. We pioneer breakthrough research to develop clinically
      validated innovations. We’re on a mission to set a new standard and evolve
      our paradigms of care.
    </Description>
    <PractitionerContainer>
      <Link prefetch={false} href='#form-hcp' legacyBehavior>
        <PractitionerButton
          onClick={() => {
            trackButtonEvent(
              'Connect with HCP',
              'Practitioners',
              hashedAccountInfo,
            );
          }}
        >
          Connect with Our Practitioner Team
        </PractitionerButton>
      </Link>
    </PractitionerContainer>
  </Section>
);

export default ConnectCta;
